import { Component, OnInit } from '@angular/core';
import { HeaderService, UserService, UtilsService } from 'src/app/_services';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, UrlSegment, Route, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-resetpassword',
  templateUrl: './resetpassword.component.html',
  styleUrls: ['./resetpassword.component.css']
})
export class ResetPasswordComponent implements OnInit {

  public resetPasswordForm: FormGroup;
  public submitted : boolean;
  public success : boolean;
  public cancelRecovery : boolean;

  constructor(
    private header: HeaderService,
    private formBuilder: FormBuilder,
    private users : UserService,
    private route : ActivatedRoute,
    private router : Router,
    private utils: UtilsService,
    private toastr : ToastrService,
    private translate : TranslateService
  ) { 
    this.header.setHeader(false,false,false,false);
  }

  get f() { 
    return this.resetPasswordForm.controls; 
  }

  ngOnInit() {
    this.submitted = false;
    this.cancelRecovery = false;
    this.success = false;

    this.resetPasswordForm = this.formBuilder.group({
      password: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(10)]],
      verifyPassword: [''],
    },{validator: [this.checkPasswords] });

    let params : any = this.route.snapshot.params;
    if (this.route.snapshot.url.find( (s : UrlSegment) => {return s.path == 'cancelpasswordrecovery' })){
      this.cancelRecovery = true;     
      this.users.cancelPasswordRecovery(params.id_user,  params.guid).subscribe(
        result =>{
            this.success = true;
        }, error => {
          this.success = false;
        });
    }
  }

  checkPasswords(group: FormGroup) {
    let pass = group.controls.password.value;
    let confirmPass = group.controls.verifyPassword.value;

    return pass === confirmPass ? null : { notSamePassword: true }     
  }
  
  onSubmit(){
    this.submitted = true;
    let params: any = this.route.snapshot.params;

    if (this.resetPasswordForm.invalid){
      return ;
    }
    
    this.users.recoverPassword(params.id_user, this.f.password.value,params.guid).subscribe(
      result => {
        this.success = true;
        this.header.scrollTop();
      },
      error => {
        this.success = false;
      }
    );


  }
}
